import { render, staticRenderFns } from "./CabecalhoOrigem.vue?vue&type=template&id=4cbadcd3&scoped=true"
import script from "./CabecalhoOrigem.vue?vue&type=script&lang=js"
export * from "./CabecalhoOrigem.vue?vue&type=script&lang=js"
import style0 from "./CabecalhoOrigem.vue?vue&type=style&index=0&id=4cbadcd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbadcd3",
  null
  
)

export default component.exports